import React from "react";

const HomePage = React.lazy(() => import("../pages/HomePage"));
const AboutPage = React.lazy(() => import("../pages/AboutPage"));
const ResourcePage = React.lazy(() => import("../pages/ResourcePage"));
const IRPage = React.lazy(() => import("../pages/IRPage"));
const IRDetailPage = React.lazy(() => import("../pages/IRDetailPage"));
const NewsPage = React.lazy(() => import("../pages/NewsPage"));
const NewsDetailPage = React.lazy(() => import("../pages/NewsDetailPage"));

const ContactUsPage = React.lazy(() => import("../pages/ContactUsPage"));
const DownloadPage = React.lazy(() => import("../pages/DownloadPage"));
const PrivacyPage = React.lazy(() => import("../pages/PrivacyPage"));

// product
const GraphRAGPage = React.lazy(() => import("../pages/Product/GraphRAGPage"));
const GenAIPage = React.lazy(() => import("../pages/Product/GenAIPage"));
const AIMarketingPage = React.lazy(() =>
  import("../pages/Product/AIMarketingPage")
);
const AgensGraphPage = React.lazy(() =>
  import("../pages/Product/AgensGraphPage")
);
const AgensSQLPage = React.lazy(() => import("../pages/Product/AgensSQLPage"));
const OntologyPage = React.lazy(() => import("../pages/Product/OntologyPage"));
// service
const PGTSPage = React.lazy(() => import("../pages/Service/PGTSPage"));
const EducationPage = React.lazy(() =>
  import("../pages/Service/EducationPage")
);
const TechPortalPage = React.lazy(() =>
  import("../pages/Service/TechPortalPage")
);

const routes = [
  { path: "/", exact: true, name: "Home", element: HomePage },
  { path: "/company", name: "About", element: AboutPage },
  { path: "/resource", name: "Resource", element: ResourcePage },
  { path: "/ir", name: "IR", element: IRPage },
  { path: "/ir/announcement/:id", name: "IRDetail", element: IRDetailPage },
  { path: "/newsroom", name: "News", element: NewsPage },
  { path: "/newsroom/:id", name: "NewsDetail", element: NewsDetailPage },

  { path: "/contact", name: "ContactUs", element: ContactUsPage },
  { path: "/download", name: "Download", element: DownloadPage },
  { path: "/privacy", name: "Privacy", element: PrivacyPage },
  // service
  { path: "/service/pgts", name: "PGTS", element: PGTSPage },
  { path: "/service/education", name: "Education", element: EducationPage },
  { path: "/service/techportal", name: "TechPortal", element: TechPortalPage },
  // product
  { path: "/product/ai/graph_rag", name: "GraphRAG", element: GraphRAGPage },
  { path: "/product/ai/video_production", name: "GenAI", element: GenAIPage },
  {
    path: "/product/ai/marketing_solution",
    name: "AIMarketing",
    element: AIMarketingPage,
  },
  {
    path: "/product/dbms/agens_graph",
    name: "AgensGraph",
    element: AgensGraphPage,
  },
  { path: "/product/dbms/agens_sql", name: "AgensSQL", element: AgensSQLPage },
  { path: "/product/ontology", name: "Ontology", element: OntologyPage },
];

export default routes;
